import { Component, inject, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { Patient } from "../../Api/DcoApi/Patient";
import { AddressEdit } from "../Controlls/AddressEdit"
import { DateSelect } from "../Controlls/DateSelect"
import { Address } from '../../Api/DcoApi/Address';
import {RestClient, Rights, User} from '../../Api/DcoApi/Client/RestClient';
import { KassenSelect } from '../Controlls/SearchAndSelect/KassenSelect';
import { CommonModule, AsyncPipe } from '@angular/common';
import { EKVNummerMaskDirective, VNummerType } from '../../Masks/EKVNummer';
import { GeschlechtsAuswahl } from '../Controlls/GeschlechtsAuswahl';
import { IsSpezialUserDirective, IsWelcomeCallDirective } from '../../Admin/AdminGuard';
import {Phonenumber} from '../../Directives/Phonenumber';
import {ConfirmDialogService} from '../../Componente/ConfirmDialog/confirm-dialog.service';
import {AuthorizeDirective} from '../../Directives/AuthorizationDirective';

@Component({
  imports: [
    CommonModule, FormsModule, AddressEdit, DateSelect, KassenSelect, EKVNummerMaskDirective, GeschlechtsAuswahl, IsWelcomeCallDirective, IsSpezialUserDirective, Phonenumber, AuthorizeDirective
  ],
  selector: 'UserEdit',
  templateUrl: './UserEdit.html',
  standalone: true,
  styleUrl: './UserEdit.css'
})
export class UserEdit implements OnInit {
  Client: RestClient = new RestClient();
  ngOnInit(): void {
    if (this.patient == null)
      this.patient = { gesetzlichVersichert: true, beihilfe: false } as Patient;
  }
  modal = inject(NgbActiveModal);
  public GKVPKV = [
    { id: true, name: 'GKV' },
    { id: false, name: 'PkV' }
  ];
  public Beihilfe = [
    { id: true, name: 'Ja' },
    { id: false, name: 'Nein' }
  ];

  private confirmService = inject(ConfirmDialogService);
  async SaveUser() {
    try {

      if (this.patient != null) {
        if (this.IsNew) {
          this.patient = await this.Client.Post<Patient, Patient>(`/Backend/Api/V2/Akte/Patient/Create`, this.patient);
        } else {
          this.patient = await this.Client.Put<Patient, Patient>(`/Backend/Api/V2/Akte/Patient/${this.KvNummer}/Update`, this.patient);
        }
        this.modal.close(this.patient)
        this.patient = null;
      }
    }catch (e: any) {
     // console.log(e);
      if(e && e.status == 409)
      {
        if(User.HasRight(Rights.AllowPatientMerge))
        {
          var res = await this.confirmService.confirm(
            'Ein Patient mit der nummer Existiert bereits! Sollen die beiden zusammegefügt werden?',
            { title: 'Patient existiert bereits', btnOkText: 'Ja', btnCancelText: 'Nein' }
          );

          if(res)
          {
            try {
              await this.Client.Put<any, any>(`/Backend/Api/V2/Akte/Patient/${this.KvNummer}/Merge/${this.patient?.versicherungsnummer}`, null);
              this.modal.close(this.patient)
              this.patient = null;
            }catch {

            }
          }

        } else
        {
          alert("Ein Patient mit der nummer Existiert bereits!");
        }

      }

        if(e && e.status == 400)
        {
          alert("Fehler beim Speichern:" + e.error );
        }
    }
  }

  get adresse() : Address | null
  {

    if (this.patient?.adressen == undefined)
    {
      if(this.patient)
        this.patient.adressen = [];

      return null;
    }


    return this.patient?.adressen[0] ?? null
  }

  set adresse(addresse: Address | null) {

    if (this.patient != null) {

      if (this.patient.adressen == undefined || this.patient.adressen == null) {
        this.patient.adressen = [];
      }

      if (addresse != null) {


        if (this.patient.adressen?.length > 0) {
          this.patient.adressen[0] = addresse;
        }
        else
          this.patient.adressen.push(addresse)
      }
      else {
        this.patient.adressen = [];
      }
    }
  }
  @Input() patient: Patient | null = { gesetzlichVersichert: true, beihilfe: false} as Patient;
  @Input() IsNew: boolean = false;
  @Input() KvNummer: string = "";

  protected get VNummerType():VNummerType
  {
    if(this.patient?.isCompany === true)
      return VNummerType.Company;

     if(this.patient?.gesetzlichVersichert === true)
      return VNummerType.GKV;
    else
      return VNummerType.PKV;
  }

  protected get VNummerEnabeld()
  {
    if(this.patient?.isCompany === true)
      return false;

    if(this.patient?.gesetzlichVersichert === true)
      return true;
    else
      return false;
  }

  protected readonly Rights = Rights;
}
